import { render } from "./MenuFooter.vue?vue&type=template&id=126caa10&scoped=true"
import script from "./MenuFooter.vue?vue&type=script&lang=js"
export * from "./MenuFooter.vue?vue&type=script&lang=js"

import "@/assets/styles/mystyles.css?vue&type=style&index=0&id=126caa10&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126caa10"]])

export default __exports__